import { PropsWithChildren } from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

type ParagraphProps = React.HTMLAttributes<HTMLSpanElement> & {
  className?: string;
  fontSize?: number;
  width?: number;
};

export const Paragraph = (
  props: PropsWithChildren<ParagraphProps>
): JSX.Element => {
  const { className, fontSize = 14, style = {}, width, ...rest } = props;
  return (
    <span
      className={cn(styles.paragraph, className)}
      style={{ ...style, fontSize: fontSize, width: `${width}px` }}
      {...rest}
    >
      {props.children}
    </span>
  );
};
